import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import BaseTableCell from 'components/molecules/TableCells/BaseTableCell/BaseTableCell';

const StyledCheckboxTableCell = styled(BaseTableCell)`
  ${ComponentStyles}
`;

StyledCheckboxTableCell.propTypes = {
  theme: PropTypes.object
};

export default StyledCheckboxTableCell;
